import { render } from "./TypeDescription.vue?vue&type=template&id=0cae797a"
import script from "./TypeDescription.vue?vue&type=script&lang=js"
export * from "./TypeDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__